import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../components/shared/services/data.service';
import { Indicador } from '../models/Indicador';

@Injectable()
export class IndicadorService extends DataService{

  private url = this.urlApi + 'v1/indicador/';

  constructor(private http: HttpClient) {
    super();
  }

  getFull(idIndicador: string) {
    return this.http.get<Indicador>(this.url + 'getFull/' + idIndicador)
      .catch(this.handleError);
  }

  getByTipoIndicador(): Observable<Indicador[]> {
    return this.http.get<Indicador[]>(this.url + 'tipoIndicador/ABD76759-7F03-4CA4-A034-6D82D4AC2D4A')
      .catch(this.handleError);
  }

  getByValor(valor): Observable<Indicador> {
    return this.http.get(this.url + 'getByValor/' + valor)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/indicador.service.ts